<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else contactInfoFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="contactInfoFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #contactInfoFlexColumnTemplate>
  <div fxFlex.lt-sm="10px" fxFlex.lt-md="60px" fxFlex.gt-sm="25px">&nbsp;</div>         <!-- 11/01/2021 RA - Increased from 10px to 60px to move info box down -->
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else contactInfoMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="contactInfoMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #contactInfoMainFlexColumnTemplate>
  <div fxFlex="50%" fxHide.lt-md></div>
  <div
    fxFlex="500px"
    fxFlex.lt-md="100%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    *ngIf="showSpinner"
  >
    <div class="display-text normal-paragraph-spacing" style="text-align: center">
      <mat-spinner color="accent" diameter="64"></mat-spinner>
    </div>
  </div>
  <div fxFlex="500px" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="!showSpinner">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column" *ngIf="this.contactInformationFound">
            <div *ngIf="isBrowserIE; else contactInfoFormFlexColumnTemplate">
              <ng-container *ngTemplateOutlet="contactInfoFormFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #contactInfoFormFlexColumnTemplate>
  <div fxLayout="column">
    <form #f="ngForm" [formGroup]="contactInfoForm">
      <div class="display-text primary-dark-color-important">
        <b><span i18n="@@contact-info.title">contact-info.title</span></b>
      </div>
      <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
      <br>
      <div class="display-text primary-dark-color-important">
        <b><center><span i18n="@@contact-info.dir_message">contact-info.dir_message</span></center></b>
      </div>
      <div class="display-text-red primary-dark-color-important2">
        <b><center><span i18n="@@contact-info.dir_message2">contact-info.dir_message2</span></center></b>
      </div>
      <div class="display-text primary-dark-color-important">
        <b><center><span i18n="@@contact-info.dir_message3">contact-info.dir_message3</span></center></b>
      </div>
      <br>
      <div
          fxLayout="row"
          fxLayout.lt-md="column"
          fxLayoutAlign="center center"
          fxLayoutGap="12px"
          class="display-text normal-paragraph-spacing"
        >
        <button
          *ngIf="!allowContactInfoEdit && !showSaveContactInformationMessageSpinner"
          mat-stroked-button
          fxFlex.lt-md="100%"
          mat-raised-button
          color="primary"
          (click)="editContactInformation()"
          i18n="@@contact-information.form.edit-contact-button.label"
        >
          contact-information.form.edit-contact-button.label
        </button>
        <button
          *ngIf="!allowContactInfoEdit && !showSaveContactInformationMessageSpinner"
          mat-stroked-button
          fxFlex.lt-md="100%"
          mat-raised-button
          color="primary"
          (click)="confirmContactInformation()"
          i18n="@@contact-information.form.confirm-contact-button.label"
        >
          contact-information.form.confirm-contact-button.label
        </button>
      </div>
      <br>
      <div class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.first-name.label"
            placeholder="contact-info.form.first-name.label"
            type="text"
            [value]="contactInformation.firstName"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.middle-initial.label"
            placeholder="contact-info.form.middle-initial.label"
            type="text"
            [value]="contactInformation.middleInitial"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.last-name.label"
            placeholder="contact-info.form.last-name.label"
            type="text"
            [value]="contactInformation.lastName"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <div class="display-text">
        <mat-form-field
          ngStyle.gt-sm="width: 80%"
          fxFlex.lt-md="90%"
          [class.text-vl]="contactInformation?.homeEmailValid === 'VL'"
          [class.text-in]="contactInformation?.homeEmailValid === 'IN'">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.home-email.label"
            placeholder="contact-info.form.home-email.label"
            type="text"
            autocomplete="email"
            [maxlength]="fieldValidations.contact.emailAddressMaxLength"
            [formControl]="homeEmailFormControl"
            [readonly]="!allowContactInfoEdit"
            [disabled]="!allowContactInfoEdit"
            required
          />
          <mat-error *ngIf="homeEmailFormControl.hasError('required')" i18n="@@contact-info.form.error.required"
            >contact-info.form.error.required</mat-error
          >
          <mat-error
            *ngIf="homeEmailFormControl.hasError('pattern') && !homeEmailFormControl.hasError('required')"
            i18n="@@contact-info.form.error.home-email"
            >contact-info.form.error.home-phone</mat-error
          >
        </mat-form-field>
      </div>
      <div class="display-text">
        <mat-form-field
          ngStyle.gt-sm="width: 80%"
          fxFlex.lt-md="90%"
          [class.text-vl]="contactInformation?.homePhoneValid === 'VL'"
          [class.text-in]="contactInformation?.homePhoneValid === 'IN'">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.home-phone.label"
            placeholder="contact-info.form.home-phone.label"
            type="text"
            autocomplete="tel-national"
            [maxlength]="fieldValidations.contact.phoneMaxLength"
            [formControl]="homePhoneFormControl"
            [readonly]="!allowContactInfoEdit"
            [disabled]="!allowContactInfoEdit"
            required
          />
          <mat-error *ngIf="homePhoneFormControl.hasError('required')" i18n="@@contact-info.form.error.required"
            >contact-info.form.error.required</mat-error
          >
          <mat-error
            *ngIf="homePhoneFormControl.hasError('pattern') && !homePhoneFormControl.hasError('required')"
            i18n="@@contact-info.form.error.home-phone"
            >contact-info.form.error.home-phone</mat-error
          >
        </mat-form-field>
      </div>
      <div class="display-text">
        <mat-form-field
          ngStyle.gt-sm="width: 80%"
          fxFlex.lt-md="90%"
          [class.text-vl]="contactInformation?.addressValid === 'VL'"
          [class.text-in]="contactInformation?.addressValid === 'IN'">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.address-line1.label"
            placeholder="contact-info.form.address-line1.label"
            type="text"
            autocomplete="address-line1"
            [maxlength]="fieldValidations.contact.addressLine1MaxLength"
            [formControl]="addressLine1FormControl"
            [readonly]="!allowContactInfoEdit"
            [disabled]="!allowContactInfoEdit"
            required
          />
          <mat-error *ngIf="addressLine1FormControl.hasError('required')"
                    i18n="@@contact-info.form.error.required">
            contact-info.form.error.required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="display-text">
        <mat-form-field
          ngStyle.gt-sm="width: 80%"
          fxFlex.lt-md="90%"
          [class.text-vl]="contactInformation?.addressValid === 'VL'"
          [class.text-in]="contactInformation?.addressValid === 'IN'">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.address-line2.label"
            placeholder="contact-info.form.address-line2.label"
            type="text"
            autocomplete="address-line2"
            [maxlength]="fieldValidations.contact.addressLine2MaxLength"
            [formControl]="addressLine2FormControl"
            [readonly]="!allowContactInfoEdit"
            [disabled]="!allowContactInfoEdit"
          />
          <mat-error *ngIf="addressLine2FormControl.hasError('required')"
                     i18n="@@contact-info.form.error.required">
            contact-info.form.error.required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="display-text">
        <mat-form-field
          ngStyle.gt-sm="width: 80%"
          fxFlex.lt-md="90%"
          [class.text-vl]="contactInformation?.addressValid === 'VL'"
          [class.text-in]="contactInformation?.addressValid === 'IN'">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.city.label"
            placeholder="contact-info.form.city.label"
            type="text"
            autocomplete="city"
            [maxlength]="fieldValidations.contact.cityMaxLength"
            [formControl]="cityFormControl"
            [readonly]="!allowContactInfoEdit"
            [disabled]="!allowContactInfoEdit"
            required
          />
          <mat-error *ngIf="cityFormControl.hasError('required')"
                     i18n="@@contact-info.form.error.required"
            >contact-info.form.error.required</mat-error>
        </mat-form-field>
      </div>
      <!-- 02/05/2020 RA Added Dropdown box
           03/19/2021 RA Moved Country before State to filter the State dropdown box based on Country  -->
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%"
          [class.text-vl]="contactInformation?.addressValid === 'VL'"
          [class.text-in]="contactInformation?.addressValid === 'IN'">
          <mat-select
            i18n-placeholder="@@contact-info.form.country.label"
            placeholder="contact-info.form.country.label"
            [formControl]="countryFormControl"
            autocomplete="off"
            [disabled]="!allowContactInfoEdit"
            required>
          <mat-option *ngFor="let country of countryList" value="{{ country.countryCode }}">{{ country.countryDescription }}</mat-option>
          </mat-select>
          <mat-error class="form-error" *ngIf="countryFormControl.hasError('required')" i18n="@@contact-info.form.error.required"
            >contact-info.form.error.required</mat-error>
        </mat-form-field>
        <span fxFlex="20%" fxHide.lt-md></span>
      </div>
      <!-- 02/05/2020 RA Added Dropdown box -->
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%"
          [class.text-vl]="contactInformation?.addressValid === 'VL'"
          [class.text-in]="contactInformation?.addressValid === 'IN'">
          <mat-select *ngIf="allowContactInfoEdit"
            i18n-placeholder="@@contact-info.form.state.label"
            placeholder="contact-info.form.state.label"
            [formControl]="stateFormControl"
            autocomplete="off"
            required
          >
            <mat-option *ngFor="let state of stateList" value="{{ state.stateCode }}">{{ state.stateDescription }}</mat-option>
          </mat-select>
          <mat-select *ngIf="!allowContactInfoEdit"
            i18n-placeholder="@@contact-info.form.state.label"
            placeholder="contact-info.form.state.label"
            [formControl]="stateFormControl"
            autocomplete="off"
            required
            disabled
          >
            <mat-option *ngFor="let state of stateList" value="{{ state.stateCode }}">{{ state.stateDescription }}</mat-option>
          </mat-select>
          <mat-error class="form-error" *ngIf="stateFormControl.hasError('required')" i18n="@@contact-info.form.error.required"
            >contact-info.form.error.required</mat-error
          >
        </mat-form-field>
        <span fxFlex="20%" fxHide.lt-md></span>
      </div>
      <div class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="allowContactInfoEdit"
          [class.text-vl]="contactInformation?.addressValid === 'VL'"
          [class.text-in]="contactInformation?.addressValid === 'IN'">
          <!-- 03/09/2021 RA - two input statements - one for zip code with only numbers, one that allows both numbers and letters -->
          <input
            matInput
            i18n-placeholder="@@contact-info.form.zip-code.label"
            placeholder="contact-info.form.zip-code.label"
            type="text"
            [formControl]="zipCodeFormControl"
            autocomplete="postal-code"
            [minLength]="getContactZipCodeMinLength(contactInfoForm.get('countryFormControl').value)"
            [maxlength]="getContactZipCodeMaxLength(contactInfoForm.get('countryFormControl').value)"
            *ngIf="!contactZipCodeOnlyAllowsNumbers()"
             />        <!--required 03/26/2021 RA - Removed required as we are doing it programmatically -->
          <input
            matInput
            i18n-placeholder="@@contact-info.form.zip-code.label"
            placeholder="contact-info.form.zip-code.label"
            type="text"
            [formControl]="zipCodeFormControl"
            autocomplete="postal-code"
            [minLength]="getContactZipCodeMinLength(contactInfoForm.get('countryFormControl').value)"
            [maxlength]="getContactZipCodeMaxLength(contactInfoForm.get('countryFormControl').value)"
            onkeypress="return isNumberKey(this, event, 0)"
            *ngIf="contactZipCodeOnlyAllowsNumbers()"
            />       <!-- required 03/26/2021 RA - Removed required as we are doing it programmatically -->
          <mat-error
            class="form-error"
            *ngIf="zipCodeFormControl.hasError('required') &&
                   (contactInfoForm.get('countryFormControl').value === 'USA' || contactInfoForm.get('countryFormControl').value === 'CAN')"
            i18n="@@contact-info.form.error.required">contact-info.form.error.required</mat-error>
          <!-- 03/10/2021 RA - Added country to error check as to not show multiple error statements -->
          <mat-error
            *ngIf="((zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength') ||
                     zipCodeFormControl.hasError('pattern') || zipCodeFormControl.hasError('required')) &&
                    contactInfoForm.get('countryFormControl').value === 'USA')"
            i18n="@@contact-info.form.error.zip-code-USA">contact-info.form.error.zip-code</mat-error>
          <!-- 03/10/2021 RA - Added Canadian error message for invalid Zip Code pattern and check country -->
          <mat-error
            *ngIf="((zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength') ||
                     zipCodeFormControl.hasError('pattern') || zipCodeFormControl.hasError('required')) &&
                    contactInfoForm.get('countryFormControl').value === 'CAN')"
            i18n="@@contact-info.form.error.zip-code-CAN">contact-info.form.error.zip-code</mat-error>
            <!-- 03/25/2021 RA - Added Foreign error message for invalid Zip Code pattern and check country -->
            <mat-error
            *ngIf="((zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength') ||
                     zipCodeFormControl.hasError('pattern')) && contactInfoForm.get('countryFormControl').value === 'FOR')"
              i18n="@@contact-info.form.error.zip-code-FOR">contact-info.form.error.zip-code</mat-error>
        </mat-form-field>
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!allowContactInfoEdit"
          [class.text-vl]="contactInformation?.addressValid === 'VL'"
          [class.text-in]="contactInformation?.addressValid === 'IN'">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.zip-code.label"
            placeholder="contact-info.form.zip-code.label"
            type="text"
            [value]="contactInformation.zipCode"
            autocomplete="off"
            readonly
            disabled />
        </mat-form-field>
      </div>
      <div class="display-text">
        <mat-form-field
          ngStyle.gt-sm="width: 80%"
          fxFlex.lt-md="90%"
          [class.text-vl]="contactInformation?.cellPhoneValid === 'VL'"
          [class.text-in]="contactInformation?.cellPhoneValid === 'IN'">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.cell-phone.label"
            placeholder="contact-info.form.cell-phone.label"
            type="text"
            autocomplete="tel-national"
            [maxlength]="fieldValidations.contact.phoneMaxLength"
            [formControl]="cellPhoneFormControl"
            [readonly]="!allowContactInfoEdit"
            [disabled]="!allowContactInfoEdit"
          />
          <mat-error *ngIf="cellPhoneFormControl.hasError('pattern')" i18n="@@contact-info.form.error.cell-phone"
            >contact-info.form.error.cell-phone</mat-error
          >
        </mat-form-field>
      </div>
      <div class="display-text">
        <mat-form-field
          ngStyle.gt-sm="width: 80%"
          fxFlex.lt-md="90%"
          [class.text-vl]="contactInformation?.workPhoneValid === 'VL'"
          [class.text-in]="contactInformation?.workPhoneValid === 'IN'">
          <input
            matInput
            i18n-placeholder="@@contact-info.form.work-phone.label"
            placeholder="contact-info.form.work-phone.label"
            type="text"
            autocomplete="tel-national"
            [maxlength]="fieldValidations.contact.phoneMaxLength"
            [formControl]="workPhoneFormControl"
            [readonly]="!allowContactInfoEdit"
            [disabled]="!allowContactInfoEdit"
          />
          <mat-error *ngIf="workPhoneFormControl.hasError('pattern')" i18n="@@contact-info.form.error.work-phone"
            >contact-info.form.error.work-phone</mat-error
          >
        </mat-form-field>
      </div>
       <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
        <button
          *ngIf="allowContactInfoEdit && !showSaveContactInformationMessageSpinner"
          mat-flat-button
          color="primary"
          (click)="saveContactInformation()"
          [disabled]="!saveContactInformationButtonEnabled()"
          i18n="@@contact-information.form.save-contact-button.label"
        >
          contact-information.form.save-contact-button.label
        </button>
        <mat-spinner color="accent" diameter="32" *ngIf="showSaveContactInformationMessageSpinner"></mat-spinner>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text highlighted-display-text normal-paragraph-spacing"
        *ngIf="showContactSaveSuccess"
      >
        <b
          ><span i18n="@@contact-information.save-contact-information-message.success"
            >contact-information.save-contact-information-message.success</span
          ></b
        >
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showContactSaveError"
      >
        <b><span i18n="@@contact-information.save-contact-information.error">contact-information.save-contact-information.error</span></b>
      </div>
    </form>
    <form [formGroup]="securityInfoForm">
      <div class="display-text primary-dark-color-important large-paragraph-pre-spacing">
        <b><span i18n="@@security-info.title">security-info.title</span></b>
      </div>
      <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
      <div class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
          <input
            matInput
            i18n-placeholder="@@security-info.form.user-name.label"
            placeholder="security-info.form.user-name.label"
            type="text"
            [value]="userNameFormControl.value"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <br>
      <div class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="allowPasswordEdit">
          <input
            matInput
            i18n-placeholder="@@security-info.form.password.label"
            placeholder="security-info.form.password.label"
            type="password"
            [formControl]="passwordFormControl"
            autocomplete="off"
            [minlength]="fieldValidations.userRegistration.passwordMinLength"
            [maxlength]="fieldValidations.userRegistration.passwordMaxLength"
            required
          />
          <mat-hint align="end" i18n="@@user-registration.form.hint.password">user-registration.form.hint.password</mat-hint>
          <mat-error
            *ngIf="passwordFormControl.hasError('pattern') && !passwordFormControl.hasError('required')"
            i18n="@@user-registration.form.error.confirm-password"
            >user-registration.form.error.confirm-password</mat-error
          >
        </mat-form-field>
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!allowPasswordEdit">
          <input
            matInput
            i18n-placeholder="@@security-info.form.password.label"
            placeholder="security-info.form.password.label"
            type="password"
            [value]="passwordFormControl.value"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <br>
      <div class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="allowPasswordEdit">
          <input
            matInput
            i18n-placeholder="@@security-info.form.password.label"
            placeholder="security-info.form.password.label"
            type="password"
            [formControl]="passwordConfirmFormControl"
            autocomplete="off"
            [minlength]="fieldValidations.userRegistration.passwordMinLength"
            [maxlength]="fieldValidations.userRegistration.passwordMaxLength"
            required
          />
          <mat-hint align="end" i18n="@@user-registration.form.hint.confirm-password">
            user-registration.form.hint.confirm-password</mat-hint
          >
          <mat-error *ngIf="passwordConfirmFormControl.hasError('required')" i18n="@@user-registration.form.error.required"
            >user-registration.form.error.required</mat-error
          >
          <mat-error
            *ngIf="passwordConfirmFormControl.hasError('pattern') && !passwordConfirmFormControl.hasError('required')"
            i18n="@@user-registration.form.error.confirm-password"
            >user-registration.form.error.confirm-password</mat-error
          >
        </mat-form-field>
      </div>
      <br>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text normal-paragraph-spacing"
        *ngIf="userPasswordEqualsFormControl.invalid && userPasswordEqualsFormControl.hasError('required')"
      >
        <span ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" fxLayoutAlign="left start">
          <mat-error
            class="form-error"
            *ngIf="userPasswordEqualsFormControl.invalid && userPasswordEqualsFormControl.hasError('required')"
            i18n="@@user-registration.form.password-equals.error"
            >user-registration.form.password-equals.error</mat-error
          >
        </span>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
        <button
          *ngIf="!allowPasswordEdit && !showSavePasswordMessageSpinner && contactInformation?.homeEmailValid === 'VL'"
          mat-flat-button
          color="primary"
          (click)="editPassword()"
          i18n="@@security-info.form.edit-password-button.label">
          security-info.form.edit-password-button.label
        </button>
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="display-text highlighted-display-text normal-paragraph-spacing"
          *ngIf="contactInformation?.homeEmailValid === 'IN'">
          <span ngStyle.gt-sm="width: 100%" fxFlex.lt-md="900%" fxLayoutAlign="left start">
              <mat-error
                class="form-error2"
                *ngIf="contactInformation?.homeEmailValid === 'IN'"
                i18n="@@forgot-password.submit-button.error.1">forgot-password.submit-button.error.1</mat-error>
          </span>
        </div>
        <button
          *ngIf="allowPasswordEdit && !showSavePasswordMessageSpinner"
          mat-flat-button
          color="primary"
          (click)="savePassword()"
          [disabled]="!savePasswordButtonEnabled()"
          i18n="@@security-info.form.save-password-button.label"
        >
          security-info.form.save-password-button.label
        </button>
        <mat-spinner color="accent" diameter="32" *ngIf="showSavePasswordMessageSpinner"></mat-spinner>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="display-text highlighted-display-text normal-paragraph-spacing"
        *ngIf="showPasswordSaveSuccess"
      >
        <b><span i18n="@@security-info.form.save-password-message.success">security-info.form.save-password-message.success</span></b>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        style="text-align: center;"
        class="display-text warning-color normal-paragraph-spacing"
        *ngIf="showPasswordSaveError"
      >
        <b><span i18n="@@security-info.form.save-password.error">security-info.form.save-password.error</span></b>
      </div>
      <div class="display-text large-paragraph-pre-spacing">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="allowSecurityQuestionEdit">
          <mat-select
            *ngIf="allowSecurityQuestionEdit"
            i18n-placeholder="@@security-info.form.security-question.label"
            placeholder="security-info.form.security-question.label"
            autocomplete="off"
            [formControl]="securityQuestionIdFormControl"
            required
          >
            <mat-option *ngFor="let index of securityQuestionsList" value="{{ index.securityQuestionId }}">{{
              index.securityQuestion
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!allowSecurityQuestionEdit">
          <input
            matInput
            i18n-placeholder="@@security-info.form.security-question.label"
            placeholder="@@security-info.form.security-question.label"
            type="text"
            [value]="getSecurityQuestionText()"
            autocomplete="off"
            readonly
            disabled
          />
        </mat-form-field>
      </div>
      <br>
      <div class="display-text">
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="allowSecurityQuestionEdit">
          <input
            matInput
            i18n-placeholder="@@security-info.form.security-answer.label"
            placeholder="security-info.form.security-answer.label"
            type="text"
            [formControl]="securityAnswerFormControl"
            [minlength]="fieldValidations.contact.securityQuestionAnswerMinLength"
            [maxlength]="fieldValidations.contact.securityQuestionAnswerMaxLength"
            autocomplete="off"
            required
          />
          <mat-hint align="end" i18n="@@security-info.form.hint.security-answer">
            security-info.form.hint.security-answer</mat-hint>
          <mat-error *ngIf="securityAnswerFormControl.hasError('required')"
             i18n="@@security-info.form.error.required"
            >security-info.form.error.required</mat-error>
          <mat-error *ngIf="securityAnswerFormControl.hasError('pattern') && !securityAnswerFormControl.hasError('required')"
             i18n="@@security-info.form.hint.security-answer"
            >security-info.form.hint.security-answer</mat-error>
        </mat-form-field>
        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%" *ngIf="!allowSecurityQuestionEdit">
          <input
            matInput
            i18n-placeholder="@@security-info.form.security-answer.label"
            placeholder="security-info.form.security-answer.label"
            type="text"
            [value]="securityAnswerFormControl.value"
            autocomplete="off"
            readonly
            disabled
          />
          <mat-hint align="end" i18n="@@security-info.form.hint.security-answer">
            security-info.form.hint.security-answer</mat-hint>
        </mat-form-field>
      </div>
      <br>
      <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
        <button
          *ngIf="!allowSecurityQuestionEdit && !showSaveSecurityQuestionMessageSpinner"
          mat-flat-button
          color="primary"
          (click)="editSecurityQuestion()"
          i18n="@@security-info.form.edit-security-button.label"
        >
          security-info.form.edit-security-button.label
        </button>
        <button
          *ngIf="allowSecurityQuestionEdit && !showSaveSecurityQuestionMessageSpinner"
          mat-flat-button
          color="primary"
          (click)="saveSecurityQuestion()"
          [disabled]="!saveSecurityQuestionButtonEnabled()"
          i18n="@@security-info.form.save-security-button.label"
        >
          security-info.form.save-security-button.label
        </button>
        <mat-spinner color="accent" diameter="32" *ngIf="showSaveSecurityQuestionMessageSpinner"></mat-spinner>
      </div>
    </form>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    class="display-text highlighted-display-text normal-paragraph-spacing"
    *ngIf="showSecurityQuestionSaveSuccess"
  >
    <b
      ><span i18n="@@security-info.form.save-security-question-message.success"
        >security-info.form.save-security-question-message.success</span
      ></b
    >
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center"
    style="text-align: center;"
    class="display-text warning-color normal-paragraph-spacing"
    *ngIf="showSecurityQuestionSaveError"
  >
    <b><span i18n="@@security-info.form.save-security-question.error">security-info.form.save-security-question.error</span></b>
  </div>
</ng-template>
